(() => {
  if (window.__awCompatibilityPurchaseGateLoaded) return;
  window.__awCompatibilityPurchaseGateLoaded = true;

  const plain = (value = '') => String(value)
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[’']/g, ' ')
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const norm = (value = '') => plain(value).replace(/\s+/g, '-');
  const csv = (value = '') => String(value).split(',').map(norm).filter(Boolean);
  const DIRECT_RELATION_STATUSES = new Set(['compatible']);

  const intersects = (left, right) => left.some((value) => right.includes(value));

  const patchRoot = (root) => {
    const instance = root?.awCatalogCompatibility;
    if (!instance || instance.__awPurchaseGatePatched) return;

    instance.__awPurchaseGatePatched = true;
    const baseEligible = instance.isEligible.bind(instance);
    const baseBadge = instance.badge.bind(instance);
    const currentModels = csv(root.dataset.currentModels || '');

    const relationDecision = (card) => {
      if (!card) return { allowed: false, reason: 'missing-card' };
      if (card.dataset.awRelationFound !== 'true') return { allowed: false, reason: 'missing-relation' };
      if (card.dataset.awRelationBlocked === 'true') return { allowed: false, reason: 'blocked' };

      const relationCount = Number(card.dataset.awRelationCount || '0');
      if (relationCount !== 1) return { allowed: false, reason: 'ambiguous-relation' };

      const status = norm(card.dataset.awRelationStatus || '');
      if (!DIRECT_RELATION_STATUSES.has(status)) {
        if (status.includes('sous-condition')) return { allowed: false, reason: 'conditional' };
        if (status.includes('adaptation')) return { allowed: false, reason: 'adaptation-required' };
        return { allowed: false, reason: 'unverified-relation' };
      }

      const confidence = Number(card.dataset.awRelationConfidence || '');
      if (!Number.isFinite(confidence) || confidence < 90) return { allowed: false, reason: 'weak-relation-proof' };
      if (!String(card.dataset.awRelationVerificationDate || '').trim()) return { allowed: false, reason: 'undated-relation' };
      if (card.dataset.awRelationProof !== 'true') return { allowed: false, reason: 'missing-relation-proof' };

      const condition = String(card.dataset.awRelationCondition || '').trim();
      if (condition) return { allowed: false, reason: 'unresolved-condition' };
      if (card.dataset.awRelationAdaptation === 'true') return { allowed: false, reason: 'adaptation-required' };

      const motif = String(card.dataset.awRelationMotif || '').trim();
      if (motif) return { allowed: false, reason: 'technical-exclusion' };

      const relationModels = csv(card.dataset.awRelationModels || '');
      if (relationModels.length) {
        if (!currentModels.length) return { allowed: false, reason: 'missing-current-model' };
        if (!intersects(currentModels, relationModels)) return { allowed: false, reason: 'model-mismatch' };
      }

      return { allowed: true, reason: 'verified-relation' };
    };

    root.__awRelationPurchaseDecision = relationDecision;

    instance.isEligible = function isEligibleWithRelationGate(card, score = this.score(card)) {
      const decision = relationDecision(card);
      if (!decision.allowed) return false;
      return baseEligible(card, score);
    };

    instance.badge = function badgeWithRelationGate(score, card) {
      const decision = relationDecision(card);
      if (!decision.allowed) {
        if (['blocked', 'technical-exclusion', 'model-mismatch'].includes(decision.reason)) {
          return 'Bloqué par Compatibility AW — achat direct interdit';
        }
        if (['conditional', 'unresolved-condition', 'adaptation-required'].includes(decision.reason)) {
          return 'Compatible sous condition — achat direct bloqué';
        }
        if (decision.reason === 'ambiguous-relation') {
          return 'Relations AW multiples — validation exacte requise';
        }
        return 'Relation AW à vérifier — achat direct bloqué';
      }
      return baseBadge(score, card);
    };

    instance.render();
  };

  const patch = (scope = document) => {
    if (scope.matches?.('[data-aw-compatible-products]')) patchRoot(scope);
    scope.querySelectorAll?.('[data-aw-compatible-products]').forEach(patchRoot);
  };

  const schedulePatch = (scope = document) => {
    patch(scope);
    window.setTimeout(() => patch(scope), 0);
    window.setTimeout(() => patch(scope), 120);
  };

  document.addEventListener('click', (event) => {
    const direct = event.target.closest?.('[data-aw-quick-add], [data-aw-product-checkbox]');
    if (direct) {
      const card = direct.closest?.('[data-aw-product-card]');
      const root = card?.closest?.('[data-aw-compatible-products]');
      const decision = root?.__awRelationPurchaseDecision?.(card);
      if (!decision?.allowed) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
    }

    const addSelected = event.target.closest?.('[data-aw-add-selected]');
    if (addSelected) {
      const root = addSelected.closest?.('[data-aw-compatible-products]');
      const checked = [...(root?.querySelectorAll?.('[data-aw-product-checkbox]:checked') || [])];
      const unsafe = checked.some((box) => {
        const card = box.closest?.('[data-aw-product-card]');
        return !root?.__awRelationPurchaseDecision?.(card)?.allowed;
      });
      if (unsafe) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }
  }, true);

  document.addEventListener('DOMContentLoaded', () => schedulePatch(document));
  document.addEventListener('shopify:section:load', (event) => schedulePatch(event.target));
})();